import RpcNodeTable from "./components/RpcNodeTable";
import { ReactComponent as Logo } from "./logo.svg";

function App() {
  return (
    <div className="min-h-screen bg-lp-midnight">
      <header className="bg-lp-space border-b border-lp-grass/20">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-4">
            <Logo className="h-8 w-auto" />
            <div className="h-6 w-px bg-lp-grass/30" />
            <span className="text-lp-light-green text-sm font-medium tracking-wider uppercase">
              RPC Nodes
            </span>
          </div>
          <a
            href="https://linkpool.io"
            target="_blank"
            rel="noopener noreferrer"
            className="text-lp-light-green/60 text-sm hover:text-lp-lime transition-colors"
          >
            linkpool.io
          </a>
        </div>
      </header>
      <RpcNodeTable />
    </div>
  );
}

export default App;
